import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import {
  AccountJournalReportServiceProxy,
  CommonLookupServiceProxy,
  DropDownLookupDto,
  ComboboxItemDto,
  BalanceSheetItemDto
} from '@shared/service-proxies/service-proxies';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppSessionService } from '@shared/common/session/app-session.service';

@Component({
  selector: 'app-trial-balance',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()],
  templateUrl: './trial-balance.component.html',
  styleUrl: './trial-balance.component.css'
})
export class TrialBalanceComponent implements OnInit {

    loading = false;

  // Dropdown Data
  locations: DropDownLookupDto[] = [];
  accounts: ComboboxItemDto[] = [];

  // Selected
  selectedLocations: any[] = [];

  // Filters
  endDate: Date = new Date();

  // Results
  trialBalance: BalanceSheetItemDto[] = [];
  groupedTrialBalance: any = {};

  // Totals
  totDebit = 0;
  totCredit = 0;

  constructor(
    private reportService: AccountJournalReportServiceProxy,
    private appSession: AppSessionService,
    private lookupService: CommonLookupServiceProxy
  ) {}

  ngOnInit(): void {
    this.loadLocations();
  }

  // Load location dropdown
  loadLocations() {
    this.lookupService.getAllLocationForTableDropdown()
      .subscribe(res => {
        this.locations = res;

        const defaultLoc = this.locations.find(x => x.id === this.appSession.user.locationId);
        if (defaultLoc) {
          this.selectedLocations = [defaultLoc];
        }
      });
  }

  // Main load event
  getDetails() {
    if (!this.endDate) return;

    const endDateStr = moment(this.endDate).format('YYYY-MM-DD');

    const locations = this.selectedLocations.length
      ? this.selectedLocations
      : this.locations;

    this.loading = true;
    this.groupedTrialBalance = {};
    this.totDebit = 0;
    this.totCredit = 0;

    this.reportService.getTrialBalance(
      0,                             // locationId (not used)
      endDateStr as any,                // endDate
      0,                             // accountId (optional)
        null,              // startDate
        this.appSession.user.locationId,           // defaultLocationId
      locations,                     // locations[]
      [],                      // accounts[]
      null,                          // transactionNo
        0,                             // customerVendorId
        0,                             // vendorId
      null,                          // journalNo
      false,                         // isAuto
      0,                             // defaultPeriod
      undefined                     // sorting
    )
    .subscribe(result => {
      this.trialBalance = result;
      this.groupData();
      this.calculateTotals();
      this.loading = false;
    });
  }

  // Group by Account Group
  groupData() {
    this.groupedTrialBalance = {};

    this.trialBalance.forEach(item => {
      if (!this.groupedTrialBalance[item.accountGroup]) {
        this.groupedTrialBalance[item.accountGroup] = [];
      }
      this.groupedTrialBalance[item.accountGroup].push(item);
    });
  }

  // Calculate Totals
  calculateTotals() {
    this.totDebit = this.trialBalance.reduce((a, b) => a + b.debit, 0);
    this.totCredit = this.trialBalance.reduce((a, b) => a + b.credit, 0);
  }

  // Export Excel
  exportExcel() {
    const endDateStr = moment(this.endDate).format('YYYY-MM-DD');

    const locations = this.selectedLocations.length
      ? this.selectedLocations
      : this.locations;

    this.loading = true;

    this.reportService.getTrialBalanceExportExcel(
        0,                             // locationId (not used)
        endDateStr as any,                // endDate
        0,                             // accountId (optional)
        null,              // startDate
        this.appSession.user.locationId,           // defaultLocationId
        locations,                     // locations[]
        [],                      // accounts[]
        null,                          // transactionNo
        0,                             // customerVendorId
        0,                             // customerVendorId
        null,                          // journalNo
        false,                         // isAuto
        0,                             // defaultPeriod
        undefined,                     // sorting

    )
    .subscribe(file => {
      // abp.downloadTempFile(file);
      this.loading = false;
    });
  }

  // Navigate to GL
  goToGeneralLedger(accountId: number) {
    const startDate = moment(this.endDate).subtract(24, 'years').format('YYYY-MM-DD');
    const endDate = moment(this.endDate).format('YYYY-MM-DD');

    const locationIds = this.selectedLocations.length
      ? this.selectedLocations.map(l => l.id).join('-')
      : this.locations.map(l => l.id).join('-');

    const url =
      `/app/account/general-ledger/${startDate},${endDate},${locationIds},${accountId}`;

    window.open(url, '_blank');
  }

}
